import { Space, Typography } from 'antd';
import React from 'react';
import { Currency, DateWithoutTimeZone, Modal } from '@common/components';
import { useMutation } from '@common/hooks';
import { createMessage } from 'works/legacy/lib/message-helper';
import { Colors } from 'works/legacy/lib/style-helper';
import {
  ArchiveInvoiceInstallmentArgs,
  ArchiveInvoiceInstallmentMutation,
  ArchiveInvoiceInstallmentResponse,
  InvoiceInstallmentFragmentType,
} from '@pay-bill/graphql';

const { Text } = Typography;

export const RemoveInstallmentModal = ({
  visible,
  onAction,
  installment,
}: {
  visible: boolean;
  onAction: () => void;
  installment: InvoiceInstallmentFragmentType;
}) => {
  const [performArchive, { loading }] = useMutation<
    ArchiveInvoiceInstallmentResponse,
    ArchiveInvoiceInstallmentArgs
  >(ArchiveInvoiceInstallmentMutation, {
    onCompleted: () => {
      createMessage('success', `Payment successfully removed`);
      onAction();
    },
    onError: () => {
      createMessage('error', 'Request failed. Please try again.');
    },
    refetchQueries: ['GetWorksInvoice'],
  });

  const onRemove = () => {
    performArchive({
      variables: {
        invoiceInstallmentId: installment.id,
      },
    });
  };

  return (
    <>
      <Modal
        visible={visible}
        cancelText="Back"
        okText="Remove"
        onCancel={onAction}
        title="Remove payment?"
        confirmLoading={loading}
        onOk={onRemove}
        danger
        className="remove-installment-modal"
      >
        <Space className="remove-installment-body">
          <Text strong>
            Payment on <DateWithoutTimeZone date={installment.paidAt} />
          </Text>
          <Text>
            Amount Paid{' '}
            <Currency value={installment.paymentAmountCents / 100} />
          </Text>
        </Space>
      </Modal>
      <style jsx>{`
        :global(.remove-installment-body) {
          background-color: ${Colors.steelLightest};
          padding: 8px 12px;
        }
      `}</style>
    </>
  );
};
